module.exports = __webpack_public_path__ + "static/img/101210.c34a5acf.png";